import {
    GET_LIST_INSTRUCTION_TEMPLATE,
    GET_SPECIFIC_INSTRUCTION_TEMPLATE,
    UPDATE_SPECIFIC_INSTRUCTION_TEMPLATE,
    CREATE_NEW_INSTRUCTION_TEMPLATE,
    REMOVE_INSTRUCTION_TEMPLATE,
    GET_INSTRUCTION_TEMPLATE_ACTIVE
} from '../actions/types';

/**
 * initial state cho module InstructionTemplate
 */
const INIT_STATE = {
    instructionTemplateList: [],
    currentInstructionTemplate: null,
    instructionTemplateActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_INSTRUCTION_TEMPLATE: {
            return {
                ...state,
                instructionTemplateList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            };
        }

        case GET_INSTRUCTION_TEMPLATE_ACTIVE: {
            return {
                ...state,
                instructionTemplateActiveList: action.payload?.data || [],
            };
        }

        case GET_SPECIFIC_INSTRUCTION_TEMPLATE: {
            return { ...state, currentInstructionTemplate: action.payload };
        }

        case CREATE_NEW_INSTRUCTION_TEMPLATE: {
            return {
                ...state,
                instructionTemplateList: [action.payload, ...state.instructionTemplateList],
                instructionTemplateActiveList: [action.payload, ...state.instructionTemplateActiveList],
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total + 1
                }
            };
        }

        case UPDATE_SPECIFIC_INSTRUCTION_TEMPLATE: {
            const updatedList = state.instructionTemplateList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            const updatedActiveList = state.instructionTemplateActiveList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            return {
                ...state,
                instructionTemplateList: updatedList,
                instructionTemplateActiveList: updatedActiveList
            };
        }

        case REMOVE_INSTRUCTION_TEMPLATE: {
            const filteredList = state.instructionTemplateList.filter(
                item => !action.payload.includes(item.id)
            );
            const filteredActiveList = state.instructionTemplateActiveList.filter(
                item => !action.payload.includes(item.id)
            );

            return {
                ...state,
                instructionTemplateList: filteredList,
                instructionTemplateActiveList: filteredActiveList
            };
        }

        default:
            return { ...state };
    }
};
